import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(@Inject(DOCUMENT) private dom: any, private title: Title, private meta: Meta) { }

  updateCanonicalUrl(url: string) {
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement = this.dom.querySelector(`link[rel='canonical']`) || null
    if (element == null) {
      element = this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical')
    element.setAttribute('href', url)
  }

  tabTitle(title:string){
    const words = title.split(" ");
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substring(1);
    }
   return  words.join(" ");
  }

  pageInfo(pagedata: any) {
    if (pagedata.title) {
      const finalTite = this.tabTitle(pagedata.title)
      this.title.setTitle(finalTite);
    } else {
      this.title.setTitle(pagedata.seoTitle);
    }
    this.meta.updateTag({ name: 'keywords', content: pagedata.seoKeyword });
    var dt = pagedata.hasOwnProperty('seoTitle');
    if (dt) {
      this.meta.updateTag({ name: 'title', content: pagedata.seoTitle });
      this.meta.updateTag({ property: 'og:title', content: pagedata.seoTitle });
    }
    this.meta.updateTag({ name: 'description', content: pagedata.seoDescription });
    this.meta.updateTag({ property: 'og:description', content: pagedata.seoDescription });
  }

}
